import React from 'react';

const LoadingListItem = () => {
  return (
    <div role="status" className="flex flex-col space-y-5 mt-14 rounded animate-pulse">
      {Array(7)
        .fill(0)
        .map(() => (
          <div>
            <div className="h-10 w-28 bg-gray-200 mb-4" />
            <div className="h-12 bg-gray-200 mb-2" />
          </div>
        ))}
      <div className="h-10 w-48 bg-gray-200 self-end " />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingListItem;
